import React, { ComponentProps, ForwardedRef, forwardRef, PropsWithChildren } from 'react'

import { bemJoin } from 'bem-join'

import { MergeProps } from '@app/lib/types'

export type CardBlockProps = MergeProps<
  ComponentProps<'div'>,
  {
    variant?: 'light'
  }
>

const b = bemJoin('lawyer-card')

export const CardBlock = forwardRef(
  (
    { variant, children }: PropsWithChildren<CardBlockProps>,
    forwardedRef: ForwardedRef<HTMLDivElement>
  ) => {
    return (
      <div
        ref={forwardedRef}
        className={b('block', {
          ...(variant && { [variant]: true })
        })}
      >
        {children}
      </div>
    )
  }
)
